import { useEffect, useState } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp, FaXTwitter } from "react-icons/fa6";

const SHARE_TEXT = "The Lifespan Project: immortality is theoretical, 150 years is practical.";

const ShareButtons = () => {
  const [url, setUrl] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setUrl(window.location.href);
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const encoded = encodeURIComponent(url);
  const text = encodeURIComponent(SHARE_TEXT);

  const buttons = [
    { id: "facebook", icon: FaFacebookF, href: `https://www.facebook.com/sharer/sharer.php?u=${encoded}` },
    { id: "x", icon: FaXTwitter, href: `https://twitter.com/intent/tweet?url=${encoded}&text=${text}` },
    { id: "whatsapp", icon: FaWhatsapp, href: `https://wa.me/?text=${text}%20${encoded}` },
    { id: "linkedin", icon: FaLinkedinIn, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}` },
    { id: "instagram", icon: FaInstagram, href: "https://www.instagram.com/" },
  ];

  return (
    <div
      data-testid="social-share-bar"
      className={`fixed bottom-4 left-1/2 z-40 hidden -translate-x-1/2 flex-row gap-3 transition-all duration-500 md:bottom-auto md:left-5 md:right-auto md:top-1/2 md:flex md:-translate-x-0 md:-translate-y-1/2 md:flex-col ${
        visible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      {buttons.map((b) => (
        <a
          key={b.id}
          href={b.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Share on ${b.id}`}
          data-testid={`share-button-${b.id}`}
          className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-surface/80 text-fog backdrop-blur transition-colors duration-300 hover:border-cyan-300/50 hover:text-white"
        >
          <b.icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
};

export default ShareButtons;
